import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../api/api';
import Swal from 'sweetalert2';

export default function AddEquipement({ onAdd }) {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';
    const [nom, setNom] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!nom.trim()) return;

        try {
            setLoading(true);
            const res = await api.post('/equipements', { nom });

            console.log('Équipement ajouté:', res.data);

            if (res.data && res.data.id) {
                onAdd(res.data); // 🔁 ajoute à la liste + coche
                Swal.fire({
                    icon: 'success',
                    title: t('success_add_equip'),
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: t('warning'),
                    text: t('unexpected_server_response')
                });
            }

            setNom('');
            setShowForm(false);
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: t('error'),
                text: t('error_add_equip')
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`my-2 ${isRtl ? 'text-right' : 'text-left'}`}>
            {!showForm ? (
                <button type="button" onClick={() => setShowForm(true)} className="text-sm text-blue-600 underline">
                    + {t('add_equipment_btn')}
                </button>
            ) : (
                <div className={`flex items-center space-x-2 mt-2 ${isRtl ? 'flex-row-reverse space-x-reverse' : ''}`}>
                    <input
                        type="text"
                        placeholder={t('equipment_placeholder')}
                        value={nom}
                        onChange={(e) => setNom(e.target.value)}
                        className={`border rounded px-2 py-1 ${isRtl ? 'text-right' : 'text-left'}`}
                        required
                    />
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={loading}
                        className="px-2 py-1 bg-green-600 text-white rounded"
                    >
                        {loading ? t('adding') : t('add')}
                    </button>
                    <button type="button" onClick={() => setShowForm(false)} className="text-red-500">
                        {t('cancel')}
                    </button>
                </div>
            )}
        </div>
    );
}
